import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CoverageAppState from '../interfaces/CoverageAppState';
import { actionCreators } from '../redux/actions';
import { formatDate } from '../../../modules/sidebarMostVisited';

const DocumentList = () => {
	const dispatch = useDispatch();
	const coverages = useSelector((state: CoverageAppState) => state.coverages)
	let isLoading = false;

	if (isLoading) {
		return <div className="notes-loader">laddar</div>;
	}

	if (coverages.length === 0) {
		return (
			<div className="coverages__list-item coverages__list-item--padding-y">
				Du verkar inte bevaka några dokument än
			</div>
		);
	}

	const toggleModal = () => dispatch(actionCreators.toggleModal());

	const promptCoverageRemoval = (pageId) => {
		dispatch(actionCreators.setSelectedPageId(pageId))
		toggleModal();
		setTimeout(() => {
			$(".bookmarks__modal-innercontainer").find(".modal__close").focus();
		}, 50);
	}

	return (
		<ol className="notes__list-wrapper">
			{coverages.map(item => (
				<li
					className="coverages__item common"
					key={item.pageId}
				>
					{!item.visited ? (
						<span className="coverages__dot"></span>
					) :
						""
					}
					<div className='notifications__notifications-item'>
						<div className="top">
							{item.documentMetaType ? (
								<div className="tag">
									<span>{item.documentMetaType}</span>
								</div>
							) : ""}
							<div className="date">{formatDate(item.createdDate.toString())}</div>
						</div>
						<div className="bottom">
							<a href={item.url} className="notifications__link-item">{item.pageName}
							</a>
							<button
								className="coverages__remove-button"
								title="Ta bort"
								onClick={(e) => { e.stopPropagation(); promptCoverageRemoval(item.pageId) }}
							><span>Ta bort</span></button>
						</div>
					</div>
				</li>
			))}
		</ol>
	);
};

export default DocumentList;